import { cn } from '@/lib/utils';

export interface HelpTextProps {
  /** Plain text; use double newlines to split into paragraphs. */
  text: string;
  className?: string;
}

export function HelpText({ text, className }: HelpTextProps) {
  const paragraphs = text
    .split(/\n\n+/)
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <div
      className={cn('space-y-3 text-sm text-muted-foreground prose', className)}
    >
      {paragraphs.map((paragraph, i) => (
        <p key={i} className="leading-relaxed">
          {paragraph}
        </p>
      ))}
    </div>
  );
}
